<template>
  <div class="todo">
    <div class="flex-container">
      <div>
        <div v-on:click="updateTodoStatus">
          <span v-show="isTodoDone">
            <i
              class="fas fa-lg fa-check-circle todoCheckBoxDone"
              v-bind:style="{ color: section.color }"
            ></i>
          </span>
          <span v-show="!isTodoDone">
            <i class="far fa-lg fa-circle" v-bind:style="{ color: section.color }"></i>
          </span>
        </div>
      </div>
      <!-- <input
        class="title"
        ref="'todo' + todo.todoID"
        :value="todoTitle"
        type="textarea"
        contenteditable="true"
        @keyup.enter="event => updateTodoTitle(event)"
        v-on:blur="event => updateTodoTitle(event)"
      />-->

      <textarea
        class="title"
        ref="'todo' + todo.todoID"
        :value="todoTitle"
        contenteditable="true"
        v-on:blur="event => updateTodoTitle(event)"
        @keydown.enter="event => updateTodoTitle(event)"
        v-on:input="event => autoExpand(event)"
        name="textarea"
        rows="1"
        maxlength="100"
        placeholder="Eg. Check the email"
      ></textarea>
      <button @click="deleteTodo" class="btn">
        <i class="far fa-trash-alt deleteIcon"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    todo: Object,
    pageID: Number
  },
  created() {
    this.$nextTick(() => {
      this.$refs["'todo' + todo.todoID"].focus();
    });
  },
  computed: {
    isTodoDone() {
      return this.$store.getters.todo(this.pageID, this.todo.todoID).isDone;
    },
    todoTitle() {
      return this.$store.getters.todo(this.pageID, this.todo.todoID).title;
    },
    section() {
      return this.$store.getters.getSectionByID(
        this.pageID,
        this.todo.sectionID
      )[0];
    }
  },
  methods: {
    updateTodoStatus() {
      let value = this.isTodoDone ? false : true;
      this.$store.commit("addOrUpdateTodo", {
        pageID: this.pageID,
        todo: {
          todoID: this.todo.todoID,
          title: this.todo.title,
          sectionID: this.todo.sectionID,
          isDone: value
        }
      });
    },
    updateTodoTitle(event) {
      if (event.keyCode == 13 && event.shiftKey) {
        return;
      }

      if (event.target.value.length != 0) {
        this.$store.commit("addOrUpdateTodo", {
          pageID: this.pageID,
          todo: {
            todoID: this.todo.todoID,
            title: event.target.value,
            sectionID: this.todo.sectionID,
            isDone: this.todo.isDone
          }
        });
      } else {
        this.$store.commit("deleteTodo", {
          pageID: this.pageID,
          todo: this.todo
        });
      }
      event.target.blur();
    },
    deleteTodo() {
      this.$store.commit("deleteTodo", {
        pageID: this.pageID,
        todo: this.todo
      });
    },
    autoExpand() {
      if (event.target.tagName.toLowerCase() !== "textarea") return;
      let field = event.target;
      // Reset field height
      field.style.height = "inherit";
      // Get the computed styles for the element
      var computed = window.getComputedStyle(field);
      // Calculate the height
      var height =
        parseInt(computed.getPropertyValue("border-top-width"), 10) +
        parseInt(computed.getPropertyValue("padding-top"), 10) +
        field.scrollHeight +
        parseInt(computed.getPropertyValue("padding-bottom"), 10) +
        parseInt(computed.getPropertyValue("border-bottom-width"), 10);
      field.style.height = height + "px";
    }
  }
};
</script>

<style scoped>
.todo {
  width: 100%;
  max-width: 500px;
  height: auto;
  border: 1.4px solid #777;
  border-radius: 15px;
  padding: 10px 20px;
  margin: 0.1em auto;
  overflow: hidden;
  display: inline-block;
}

.flex-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
}

.title {
  height: 1.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
  display: inline-block;
  font-size: 1.1rem;
  margin: auto 8px;
  overflow: hidden;
  border: 0px solid transparent;
}

[contenteditable]:focus {
  outline: 0px solid transparent;
}

input[type="search"]::-webkit-search-cancel-button {
  color: #000;
}

.deleteIcon {
  color: rgb(182, 4, 4);
}

.todoCheckBoxDone {
  color: green;
}

.deleteIcon:hover {
  color: rgb(119, 3, 3);
}
</style>